module.exports = {"post_code":"Street code","SaleCreatePanel::address":"Address (incl. Post code)"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/en-GB.json
// module id = 2277
// module chunks = 260